import { GenericServiceError, StatusCodes } from '@dock/common';

export const is401Error = (error: unknown) =>
    error instanceof GenericServiceError && error.status === StatusCodes[401];
